import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class StudentStageStatusService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.STUDENT_STAGE_STATUS(), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.STUDENT_STAGE_STATUS_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.STUDENT_STAGE_STATUS(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.STUDENT_STAGE_STATUS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.STUDENT_STAGE_STATUS(id), data);
    }
}
